import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import PcpReferralUsersView from '../components/views/pcpReferralUsersView'
import { Page, PageHeader } from '../ui'

function PcpReferralUsers() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="PCP Referral"
                        title="PCP Referral Users"
                        intro="Manage Engagement users and organise them into teams. Newly-created users receive a temporary password by email and must change it on first sign-in."
                    />
                    <PcpReferralUsersView />
                </Page>
            </MainView>
        </div>
    )
}

export default PcpReferralUsers
